export interface Dataset {
  creditToUse:number
  description:string
  id:string
  mode:string
  name:string
  clarificationPrompt:string
  ragThreshold:number
  userCanUse?:string[];
  editable?:boolean;
  ownedBy?:string;
}
export interface DatasetFile {
  fileId: string 
  title: string
}
export const isDatasetFile = (file) =>{
  return typeof file === 'object' && 'fileId' in file
}

export class CreateDatasetRef {
  datasetName:string
  datasetDescription?:string
  creditToUser?:number = 0
  userCanUse?:string
  datasetMode?:string = 'private'
}

export type ModifyDatasetAction = 'delete'| 'updateInfo'| 'removeFile'| 'addDocument'| 'getFileList' | 'getInfo'